import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { BCLedgerTopClientRptExcelRequestDto } from "../models/reports/bcLedgerTopClientRptExcelRequestDto";
import { BCLedgerTopClientRptRequestDto } from "../models/reports/bcLedgerTopClientRptRequestDto";
import { BCLedgerTopClientRptResponseDto } from "../models/reports/bcLedgerTopClientRptResponseDto";
import { CreateCustOpenInvoiceNoteRequestDto } from "../models/reports/createCustOpenInvoiceNoteRequestDto";
import { CreateCustOpenInvoiceNoteResponseDto } from "../models/reports/createCustOpenInvoiceNoteResponseDto";
import { CustomerAgingDetailReport } from "../models/reports/customerAgingDetailReport";
import { CustomerSettlementHistoryDetailValue } from "../models/reports/customerSettlement";
import { GetLoginUserCollecterDetailsForEmailsRequestDto } from "../models/reports/getLoginUserCollecterDetailsForEmailsRequestDto";
import { GetLoginUserCollecterDetailsForEmailsResponseDto } from "../models/reports/getLoginUserCollecterDetailsForEmailsResponseDto";
import { GetOpenClientCreditsResponse } from "../models/reports/getOpenClientCreditsResponse";
import { GetYearToYearSummaryTigerDetailsResponse } from "../models/reports/getYearToYearSummaryTigerDetailsResponse";
import { OpenCustomerInvoiceDetailsResponse } from "../models/reports/openCustomerInvoiceDetailsResponse";
import { OrdersInvoicedDetailsRequest } from "../models/reports/orderBilledInvoiceDetailsRequestDto";
import { OrdersInvoicedDetailsResponse } from "../models/reports/ordersInvoicedDetailsResponse";
import { OrdersWrittenReportDetailResponse } from "../models/reports/ordersWrittenReportDetailResponse";
import { ReadyToBillDto } from "../models/reports/readyToBillDto";
import { YearOverYearSummaryResponse } from "../models/reports/yearToYearSummaryResponseDto";
import { GenericRequestDto } from "../models/generic-request.dto";

@Injectable({
  providedIn: "root",
})
export class ReportsService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";

  private d365SynchroniserBaseURL = environment.baseUrl + "/D365Synchroniser";
  private reportBaseURL = environment.baseUrl + "/Reports";
  constructor(private _http: HttpClient) {}

  getOrdersWrittenReportDetail(): Observable<
    GenericResponseDto<OrdersWrittenReportDetailResponse[]>
  > {
    return this._http.get<
      GenericResponseDto<OrdersWrittenReportDetailResponse[]>
    >(this.saleOrderManagementBaseURL + `/GetOrdersWrittenReportDetail`);
  }

  getOrdersWrittenReportDetailPaginated(
    request: GenericRequestDto
  ): Observable<GenericResponseDto<OrdersWrittenReportDetailResponse[]>> {
    return this._http.post<
      GenericResponseDto<OrdersWrittenReportDetailResponse[]>
    >(this.reportBaseURL + `/GetOrdersWrittenReportDetailPaginated`, request);
  }

  createCustOpenInvoiceNote(
    request: CreateCustOpenInvoiceNoteRequestDto
  ): Observable<GenericResponseDto<CreateCustOpenInvoiceNoteResponseDto>> {
    return this._http.post<
      GenericResponseDto<CreateCustOpenInvoiceNoteResponseDto>
    >(this.reportBaseURL + `/CreateCustOpenInvoiceNote`, request);
  }

  getLoginUserCollecterDetailsForEmails(
    request: GetLoginUserCollecterDetailsForEmailsRequestDto
  ): Observable<
    GenericResponseDto<GetLoginUserCollecterDetailsForEmailsResponseDto>
  > {
    return this._http.post<
      GenericResponseDto<GetLoginUserCollecterDetailsForEmailsResponseDto>
    >(this.reportBaseURL + `/GetLoginUserCollecterDetailsForEmails`, request);
  }

  ordersInvoicedDetail(
    request: OrdersInvoicedDetailsRequest
  ): Observable<GenericResponseDto<OrdersInvoicedDetailsResponse[]>> {
    return this._http.post<GenericResponseDto<OrdersInvoicedDetailsResponse[]>>(
      this.reportBaseURL + `/OrdersInvoicedDetails`,
      request
    );
  }

  getCustomerAgingDetailReport(): Observable<
    GenericResponseDto<CustomerAgingDetailReport[]>
  > {
    return this._http.get<GenericResponseDto<CustomerAgingDetailReport[]>>(
      this.reportBaseURL + `/GetCustomerAgingDetailReport`
    );
  }

  getCustomerAgingDisputeReport(): Observable<
    GenericResponseDto<CustomerAgingDetailReport[]>
  > {
    return this._http.get<GenericResponseDto<CustomerAgingDetailReport[]>>(
      this.reportBaseURL + `/GetCustomerAgingDisputeReport`
    );
  }

  getCustomerSettlement(
    oDataFilter: string
  ): Observable<GenericResponseDto<CustomerSettlementHistoryDetailValue[]>> {
    return this._http.get<
      GenericResponseDto<CustomerSettlementHistoryDetailValue[]>
    >(
      this.d365SynchroniserBaseURL +
        `/GetCustomerSettlementHistory?odataFilter=${oDataFilter}`
    );
  }
  // cusomterInvoicedDetail(): Observable<
  //   GenericResponseDto<OpenCustomerInvoiceDetailsResponse[]>
  // > {
  //   return this._http.get<
  //     GenericResponseDto<OpenCustomerInvoiceDetailsResponse[]>
  //   >(this.saleOrderManagementBaseURL + `/OpenCustomerInvoiceDetails`);
  // }
  cusomterInvoicedDetail(
    clientId?: string
  ): Observable<GenericResponseDto<OpenCustomerInvoiceDetailsResponse[]>> {
    const url = clientId
      ? `${this.reportBaseURL}/OpenCustomerInvoiceDetails?clientId=${clientId}`
      : `${this.reportBaseURL}/OpenCustomerInvoiceDetails?clientId=`;

    return this._http.get<
      GenericResponseDto<OpenCustomerInvoiceDetailsResponse[]>
    >(url);
  }

  public getReadyToBillReport(): Observable<
    GenericResponseDto<ReadyToBillDto[]>
  > {
    return this._http.get<GenericResponseDto<ReadyToBillDto[]>>(
      this.reportBaseURL + `/GetOrderBillingStatus`
    );
  }

  getOpenClientCreditsReport(): Observable<
    GenericResponseDto<GetOpenClientCreditsResponse[]>
  > {
    return this._http.get<GenericResponseDto<GetOpenClientCreditsResponse[]>>(
      this.reportBaseURL + `/GetOpenClientCredits`
    );
  }

  getRptClientReport(
    requestBody: BCLedgerTopClientRptRequestDto
  ): Observable<BCLedgerTopClientRptResponseDto> {
    return this._http.post<BCLedgerTopClientRptResponseDto>(
      this.d365SynchroniserBaseURL + `/GetBcLedgerTopClientRptReport`,
      requestBody
    );
  }

  getRptClientExcelReport(
    requestBody: BCLedgerTopClientRptExcelRequestDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.post<GenericResponseDto<string>>(
      this.d365SynchroniserBaseURL + `/GetBcLedgerTopClientRptExcelReport`,
      requestBody
    );
  }

  getYearToYearSummaryReport(
    year: string,
    bcId: string
  ): Observable<GenericResponseDto<YearOverYearSummaryResponse>> {
    return this._http.get<GenericResponseDto<YearOverYearSummaryResponse>>(
      this.reportBaseURL +
        `/GetYearToYearSummaryReport?year=${year}&bcId=${bcId}`
    );
  }

  getYearToYearSummaryReportByClient(
    year: string,
    bcId: string
  ): Observable<GenericResponseDto<YearOverYearSummaryResponse>> {
    return this._http.get<GenericResponseDto<YearOverYearSummaryResponse>>(
      this.reportBaseURL +
        `/GetYearToYearSummaryReportByClient?year=${year}&bcId=${bcId}`
    );
  }

  getYearToYearSummaryTigerDetails(
    year: string,
    selectedYearTotalGpValue: number
  ): Observable<GenericResponseDto<GetYearToYearSummaryTigerDetailsResponse>> {
    return this._http.get<
      GenericResponseDto<GetYearToYearSummaryTigerDetailsResponse>
    >(
      this.reportBaseURL +
        `/GetYearToYearSummaryTigerDetails?year=${year}&selectedYearTotalGpValue=${selectedYearTotalGpValue}`
    );
  }

  getYearToYearSummaryReportExcel(
    year: string,
    bcId: string,
    reportType: number
  ): Observable<GenericResponseDto<string>> {
    return this._http.get<GenericResponseDto<string>>(
      this.reportBaseURL +
        `/GetYearToYearSummaryReportExcel?year=${year}&bcId=${bcId}&reportType=${reportType}`
    );
  }
}
